<template>
  <mv-page>
    <mv-default-row>
      <v-layout row wrap>
        <v-flex v-if="connected && !profile && ($vuetify.breakpoint.sm || $vuetify.breakpoint.xs)" xs12>
          <v-card flat>
            <v-card-title primary-title>
              <h2>Добро пожаловать!</h2>
            </v-card-title>
            <v-card-actions >
              <v-btn block outline color="primary" dark href="/#/login">Вход в систему</v-btn>
            </v-card-actions>
            <v-card-actions>
              <v-btn block outline color="primary" dark href="/#/signup">Регистрация</v-btn>
            </v-card-actions>
            <br />
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat>
            <v-card-text>
              <h2>
                Транспортная карта, что это?
              </h2>
              <p class="pt-4">
                Транспортная карта (электронная карта) - электронное устройство в виде <b>SMART</b>-карты стандарта <b>MIFARE</b>.
                <br />
                Карта используется в качестве
                <ul>
                  <li class="mt-3 li-marker">
                    <b>идентификатора для безналичной оплаты проезда</b> в автомобильном и электрифицированном <b>транспорте</b> общего пользования (кроме такси)
                  </li>
                  <li class="mt-3 li-marker">
                    <b>идентификатора для безналичной оплаты школьного питания</b> в образовательных организациях с использованием автоматизированной системы безналичной оплаты школьного питания
                  </li>
                  <li class="mt-3 li-marker">
                    <b>пропуска для прохода в здания учебные и другие заведения</b>, оснащенные автоматизированной системой контроля доступа
                  </li>
                </ul>
                Транспортная карта (электронная карта) содержит компоненты программного обеспечения Системы (в том числе транспортное приложение), необходимые для ее функционирования в Системе.
                <br>
                Для осуществления операции безналичной оплаты школьного питания с использованием транспортной карты в столовых образовательных организациях
                учащимся и работникам образовательных организаций необходимо приложить транспортную карту к специальному терминалу.
                При необходимости, допускается централизованная оплата комплексного питания (при формировании учителем заявок).
                <br />
              </p>

              <h2>Зачем нужна регистрация в ЛК?</h2>
              <p class="pt-4">
                При использования функциональных возможностей безналичной оплаты питания в школьной столовой и прохода через турникет в образовательную организацию, так же Вы получите возможность:
                <ul>
                  <li class="mt-3 li-marker">Получать информацию о произведенных операциях по карте;</li>
                  <li class="mt-3 li-marker">Самостоятельно контролировать баланс карты;</li>
                  <li class="mt-3 li-marker">Получать доступ к дополнительным сервисам: включать и отключать сервис уведомлений о входе и выходе учащегося из образовательной организации, о поступлении денежных средств, об остатке средств на счете карты, об оплате питания в столовой с указанием перечня товаров и цен;</li>
                  <li class="mt-3 li-marker">Оперативно блокировать счет карты питания в случае ее утраты.</li>
                </ul>
              </p>

              <h2>Как пополнить транспортную карту?</h2>
              <p class="pt-4">
                Транспортная карта содержит <strong>два</strong> обособленных счета, предназначенных для оплаты проезда и питания.
                <h4>ПИТАНИЕ:</h4>
                <ul>
                  <li class="mt-3 li-marker">
                    Пополнение счета карты на питание осуществляется по номеру карты, через терминалы Сбербанка, банка Хлынов,
                    Сбербанк ONLINE и личный кабинет банка «Хлынов», а также с помощью Системы быстрых платежей.
                    Инструкции пополнения счета школьного питания: <a href="https://deti.cdsvyatka.com/#/pay" target="__blank">https://deti.cdsvyatka.com/#/pay</a>
                  </li>
                </ul>
                <br /><br />
                <h4>ТРАНСПОРТ:</h4>
                <ul>
                  <li class="mt-3 li-marker">
                    Посредством отложенного пополнения по номеру карты через Сбербанк ONLINE и личный кабинет банка «Хлынов»,
                    через платежные терминалы Сбербанка, банка «Хлынов», а также с помощью Системы быстрых платежей.
                    При этом запись денежных средств на счет карты проезда производится непосредственно в процессе оплаты проезда
                    в транспорте общего пользования и может достигать 24 часов.
                  </li>
                  <li class="mt-3 li-marker">
                    Если Вы планируете осуществить проезд в общественном транспорте в текущий день,
                    то пополнение счета карты проезда следует произвести через платежные терминалы банка АО КБ «Хлынов»
                    (пополнение возможно только путем прикладывания карты к специализированному устройству на терминале);
                  </li>
                </ul>
                <br />
                С инструкциями пополнения транспортного счета электронной карты Вы можете ознакомться по следующим ссылкам:
                <ul>
                  <li class="mt-3 li-marker">
                    <a href="https://vk.com/s/v1/doc/qx9-jNNINq79Dha2bTOW8JeuXd2ltBQFon3iibOpqClWEhUPYfU" target="__blank">Пополнение через Сбербанк ONLINE</a>
                  </li>
                  <li class="mt-3 li-marker">
                    <a href="https://vk.com/s/v1/doc/RdTS50DRAYt3cCITWXlex2tr4CAeSTcDz_DaY3AtWgTQHJZntzk" target="__blank">Пополнение через систему быстрых платежей (СБП)</a>
                  </li>
                  <li class="mt-3 li-marker">
                    <a href="https://vk.com/s/v1/doc/vBe9J_fEKQHtBJFWN7kvWczwDQRRR08X-tdnCbL0eVs_rhVO6rY" target="__blank">Пополнение через сервис отложенного пополнения банка Хлынов</a>
                  </li>
                </ul>
              </p>

              <h2>Что делать, если ребенок потерял карту?</h2>
              <p class="pt-4">
                Транспортная карта содержит <strong>два</strong> обособленных счета, предназначенных для оплаты проезда и питания.
                <br>
                В случае утраты транспортной карты, счёт питания необходимо <strong>заблокировать</strong>,  в Личном кабинете (напротив номера карты нажать <strong>замок</strong>),
                чтобы исключить возможность ее использования другими лицами на кассе в столовой, а также  в качестве пропуска  через турникет.
                <br><br>
                Карта будет доступна только для централизованной оплаты комплексного питания при формировании учителем заявки.
                <br><br>
                При утере, поломке, неисправности - счёт проезда необходимо заблокировать в Претензионном центре МБУ «ЦДС ГПТ».
                Обратитесь по телефону <a href="tel:+78332485999" target="_blank">(8332) 485-999</a>, при обращении нужно будет назвать номер карты.
                Блокировка и замена транспортной карты осуществляются только при обращении лица, на имя которого выдана карта, либо его представителя
                <br><br>
                Повторное изготовление карты производится на платной основе. При блокировке персональной транспортной карты (в связи с утерей,
                поломкой либо неисправностью транспортной карты) перевод остатка денежных средств с заблокированной транспортной карты на вновь
                приобретенную транспортную карту осуществляется на следующий рабочий день после блокировки транспортной карты.
                Для этого Пользователю либо его представителю необходимо повторно обратиться в Претензионный центр МБУ «ЦДС ГПТ» с документом,
                удостоверяющим личность, и вновь приобретенной транспортной картой.
              </p>

              <h2>Как отключить уведомления?</h2>
              <p class="pt-4">
                <ul>
                  <li class="mt-3 li-marker">
                    <h4>Отключение смс-сообщений:</h4>
                    Под номером телефона отключите не нужные подписки с помощью бегунка.
                    Для отключения номера от всех подписок сразу - нажмите на значок "замок" рядом с номером телефона.
                  </li>
                  <li class="mt-3 li-marker">
                    <h4>Отключение email-информирования:</h4>
                    Под адресом электронной почты отключите все не нужные подписки (с помощью бегунка).
                    Для отключения адреса от всех подписок сразу - нажмите на значок "замок" рядом с адресом электронной почты.
                    При полном отключении адреса электронной почты:
                    <br><br>
                    <ul>
                      <li>Будут отключены все подписки;</li>
                      <li>Адрес нельзя будет использовать для востановления пароля;</li>
                      <li>Адрес не будет учитываться при связывании аккаунтов;</li>
                      <li>Используйте в случае, если вы больше не владеете данным адресом.</li>
                    </ul>
                  </li>
                  <li class="mt-3 li-marker">
                    <h4>Отключение информирования в мессенджере Телеграмм:</h4>
                    Под номером телефона отключите не нужные подписки с помощью бегунка.
                    Для отключения номера от всех подписок сразу - нажмите на значок "замок" рядом с номером телефона.
                  </li>
                  <li class="mt-3 li-marker">
                    <h4>Отключение информирования в мессенджере Вайбер:</h4>
                    Под номером телефона отключите не нужные подписки с помощью бегунка.
                    Для отключения номера от всех подписок сразу - нажмите на значок "замок" рядом с номером телефона.
                  </li>
                  <li class="mt-3 li-marker">
                    <h4>Отключение информирования в социальной сети ВК:</h4>
                    Под идентификатором аккаунта ВК отключите не нужные подписки с помощью бегунка.
                    Для отключения аккаунта ВК от всех подписок сразу - нажмите на значок "замок" рядом с идентификатором аккаунта ВК.
                  </li>
                </ul>
              </p>

              <h2>Как привязать карту второго ребенка к личному кабинету?</h2>
              <p class="pt-4">
                Карту второго ребенка регистрируете так же, как и первого. Важно, чтобы адрес электронной почты был такой же.
                <br><br>
                Далее, в Личном кабинете на сайте <a href="https://deti.cdsvyatka.com" target="__blank">deti.cdsvyatka.com</a>, в правом верхнем углу, рядом с вкладкой "о сервисе" нажать имя школьника,
                выйдет следующая информация - действия "выход" ниже будет строка "выбор пользователя". выбираем школьника который необходим,
                нажимаем на него и отслеживаем информацию по питанию.
              </p>

              <h2>
                Мой ребенок не питался, а деньги все равно списали.
              </h2>
              <p class="pt-4">
                Обратитесь в школу, централизованная оплата комплексного питания ( формирование заявок) осуществляется <b>классным руководителем</b>,
                либо лицом его замещающим. Выясните ситуацию. Если списание было ошибочным, его отменят.
              </p>
              <br />

              <h2>Требуется ли перевыпуск карты, если ученик переводится из одной школы в другую?</h2>
              <p class="pt-4">
                При переводе учащегося в другую образовательную организацию при функционировании в ней Системы безналичной оплаты питания
                в школьных столовых и системы контроля доступа по электронным картам, карту менять не нужно, она остается у учащегося.
                В предыдущей образовательной организации учащегося своевременно исключают из базы данных, а для внесения в новую необходимо
                сообщить о наличии карты (назвать ответственному лицу номер, который на карте).
              </p>

              <h2>Надо ли активировать карту каждый учебный год?</h2>
              <p class="pt-4">
                Транспортная карта выдается учащемуся на все время обучения в образовательной организации.
                По окончанию учебного года карту менять не нужно. Баланс на счете питания сохраняется и его можно использовать в следующем учебном году.
              </p>

              <h2>Можно ли оплачивать за обеды со счета проезда и наоборот?</h2>
              <p class="pt-4">
                Транспортная карта содержит ДВА обособленных счета, предназначенных для оплаты проезда и питания.
                <br>Оплатить за школьное питание со счёта карты предназначенного для оплаты за транспорт и наоборот <b>нельзя</b>.<br>
              </p>

              <h2>Где можно просмотреть баланс транспортной карты?</h2>
              Баланс по питанию – в Личном кабинете на сайте по адресу <a href="https://deti.cdsvyatka.com" target="__blank">deti.cdsvyatka.com</a>.
              <br><br>
              Баланс счета карты проезда можно просматривать на каждом последнем билете, на экране терминала банка Хлынов.
              Также можно отслеживать баланс по проезду можно в интернет-банке, но информация о балансе носит справочный характер,
              т.к. могут отсутствовать данные о последних операциях по оплате проезда (ввиду процесса обновления информации в Системе и
              сверки с данными транспортных терминалов перевозчиков, которые производятся не в режиме реального времени, а в определенном Системой периоде).



              <h2>
                Что делать, если ребенок потерял карту?
              </h2>
              <p class="pt-4">
                <i><b>ВНИМАНИЕ!</b>  БАЛАНС ПО ПИТАНИЮ И БАЛАНС ПО ТРАНСПОРТУ ВЕДУТСЯ ОТДЕЛЬНО ДРУГ ОТ ДРУГА!
                </i>
              </p>
              <p>
                <ul>
                  <li class="mt-3 li-marker">
                    В случае потери электронной карты, <b>счёт на питание необходимо <a href="/#/settings">заблокировать</a></b>,
                    чтобы исключить возможность ее использования другими лицами на кассе в столовой и проход через турникет.
                    <br />
                    Если ребенок питается комплексно, то он сможет пообедать, <b>блокировка на комплексное питание не влияет.</b>
                  </li>
                  <li class="mt-3 li-marker">
                    При утере, поломке, неисправности <b>счёт по проезду</b> персональной электронной карты школьника необходимо заблокировать
                    <b>в Претензионном центре <a target="_blank" href="http://cdsvyatka.com">МБУ «ЦДС ГПТ»</a></b>. Обратитесь по телефону <a href="tel:+78332485999" target="_blank">(8332) 485-999</a>,
                    при обращении нужно будет назвать номер карты.
                    <br />
                Блокировка и замена электронной карты осуществляются только <b>при обращении лица, на имя которого выдана карта, либо его представителя</b>
                (для ребенка его законными представителями являются родители, опекуны, попечители).
                  </li>
                  <li class="mt-3 li-marker">
                    Повторное изготовление карты производится на платной основе – <b>100 рублей</b>
                  </li>
                </ul>
              </p>
              <br />

              <h2>
                Что делать есть денежные средства остались на счёте питания, а учебный год закончился?
              </h2>
              <p class="pt-4">Неиспользованный остаток является переходящим и <b>может быть использован в следующем учебном году.</b>
              </p>
              <br />

              <h2>
                Можно ли оплачивать услуги с разных счётов?
              </h2>
              <p class="pt-4">
                Оплатить за школьное питание со счёта «Транспортного приложения» <b>невозможно</b>, так же как и оплатить проезд в общественном транспорте со счёта школьного питания.
              </p>
              <br />

              <h2>
                Можно ли в электронной карте сделать отверстие для шнурка, чтобы ребенок мог носить ее на шее?
              </h2>
              <p class="pt-4">
                <b>Нет.</b> Транспортная карта по всему периметру оснащена специализированной антенной, поэтому любое механическое воздействие на нее приведет к повреждению. Для удобства можно приобрести чехол,обложку, бейдж и так далее.
              </p>
              <br />

              <h2>Школьники 1-4 класс все ездят бесплатно?</h2>
              <p class="pt-4">
                Все учащиеся осуществляют оплату проезда за полную стоимость. Бесплатно с 1 по 4 класс, при подтвержденном праве на льготный проезд по доходу семьи.
                При возникновении права на бесплатный или льготный (частично платный) проезд законным представителям учащегося следует обратиться в областные государственные учреждения
                социальной защиты населения в муниципальных образованиях по месту жительства, либо в многофункциональные центры (МФЦ), или подать заявление через федеральную
                государственную информационную систему "Единый портал государственных и муниципальных услуг (функций)".
              </p>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-card flat>
            <v-card-text>
              <h2>Читайте также:</h2>
              <!-- <h3><a href="/#/pay">Как пополнить карту на питание</a></h3> -->
              <h3 v-if="false"><a href="/#/sms">Как управлять сервисом с помощью смс-команд</a></h3>
              <h3><a href="/#/additionalservices">Дополнительные платные услуги, оказываемые МБУ «ЦДС ГПТ»</a></h3>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </mv-default-row>
  </mv-page>
</template>

<script>
export default {
  computed: {
    profile () {
      return this.$store.state.profile
    },
    connected () {
      return this.$store.state.connected
    },
  },
}
</script>

<style lang="css">
.li-marker {
  list-style-type: disc;
  margin: 0 20px;
}
</style>
